import mitt from 'mitt';

const bus = mitt();

export function useEventBus() {
    return bus;
}
